import { combineReducers } from 'redux';
import { UserReducer, UserState } from '../reducers/user.reducer';

// const Store = createStore(UserReducer);

export interface RootStoreModel {
  userState: UserState;
}

export const RootReducer = combineReducers({
  userState: UserReducer
});
